export const bodyWidth = {
  xs: '100%',
  sm: 540,
  md: 720,
  lg: 960,
  xl: '80%',
};
